import { ArrowLeft } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import styles from "./StaticPage.module.css";

export default function PrivacyPage(): JSX.Element {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <div className={styles.pageWrapper} data-theme={theme}>
      <nav className={styles.nav}>
        <div className={styles.navContent}>
          <button className={styles.backButton} onClick={() => navigate('/home')}>
            <ArrowLeft size={20} /> Back to Home
          </button>
          <div className={styles.logo}>xquant</div>
        </div>
      </nav>

      <main className={styles.content}>
        <h1>Privacy Policy</h1>
        <p className={styles.lastUpdated}>Last updated: January 2026</p>
        
        <section>
          <h2>Information We Collect</h2>
          <p>
            When you use xquant, we collect information you provide directly to us, including:
          </p>
          <ul>
            <li>Account information (email, name) when you sign up</li>
            <li>Chat conversations and strategy queries you submit</li>
            <li>Custom data you upload for analysis</li>
            <li>Usage data and analytics to improve our service</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process your requests and respond to your inquiries</li>
            <li>Send you technical notices and support messages</li>
            <li>Analyze usage patterns to enhance user experience</li>
          </ul>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information. 
            Your data is encrypted in transit and at rest. We do not sell your personal 
            information to third parties.
          </p>
        </section>

        <section>
          <h2>Data Retention</h2>
          <p>
            We retain your information for as long as your account is active or as needed to 
            provide you services. You can request deletion of your data at any time by 
            contacting us.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, please contact us at{' '}
            <a href="mailto:aiquant100@gmail.com">aiquant100@gmail.com</a>
          </p>
        </section>
      </main>

      <footer className={styles.footer}>
        <p>© {new Date().getFullYear()} xquant — All rights reserved.</p>
      </footer>
    </div>
  );
}
